/**
 * Series configuration types and static series definitions.
 *
 * Clustering and Strategy series are dynamically discovered via
 * the listSeries cloud function (see timeseriesClient.ts).
 * Only Benchmark and Indicator series remain hardcoded here.
 */

export interface SeriesConfig {
    id: string;
    name: string;
    series: string;
}

export interface IndicatorSeriesConfig extends SeriesConfig {
    key: string;
    getValue: (data: Record<string, any>) => number;
}

// Benchmark dropdown options
export const BENCHMARK_SERIES: SeriesConfig[] = [
    {
        id: 'btc_usd',
        name: 'BTC/USD',
        series: 'cryptocompare.cccagg.btc-usd.candle.86400000000000',
    },
    {
        id: 'eth_usd',
        name: 'ETH/USD',
        series: 'cryptocompare.cccagg.eth-usd.candle.86400000000000',
    },
];

// Indicator series for speedometer gauges
export const INDICATOR_SERIES: IndicatorSeriesConfig[] = [
    {
        id: 'newgate_altcoin_indicator',
        name: 'Altcoin Indicator',
        key: 'altcoin',
        series: 'strategy-service.indicator:binance:altcoin_season.crypto.indicator.86400000000000',
        getValue: (data) => data.indicator,
    },
    {
        id: 'newgate_bitcoin_indicator',
        name: 'Bitcoin Indicator',
        key: 'btc',
        series: 'strategy-service.rotation:ethereum:v1_btc_dist:sharpe_ratio_730:top_20.crypto.strategy.86400000000000',
        getValue: (data) => data.target_distribution?.btc,
    },
    {
        id: 'newgate_ethereum_indicator',
        name: 'Ethereum Indicator',
        key: 'eth',
        series: 'strategy-service.rotation:ethereum:v1_eth_dist:sharpe_ratio_730:top_10.crypto.strategy.86400000000000',
        getValue: (data) => data.target_distribution?.eth,
    },
];
